module.exports = __webpack_public_path__ + "media/images/emblems/Inwil_LU-099f86835c9e10a05d918439f827043d.png";